/***
**Module Name: Footer 
 **File Name :  Footer.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran Kumar
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains Footer component details.
 ***/
import React from "react";


const Footer = (props) => {
  return (
    <>   <div className="footer_block">
      <p>© {new Date().getFullYear()} Dadi. All rights reserved.</p>
    </div>
    </>
  );
};

export default Footer;
